export const MOTORCYCLE_MODELS = [
  {
    id: 'terra',
    name: 'Terra',
    basePrice: 1750000,
    image: '/ProduitTerra.png',
    description: 'Notre modèle phare robuste et puissant, idéal pour les professionnels et la livraison',
    specs: {
      autonomie: '120 km',
      vitesse: '45 km/h',
      poids: '95 kg'
    },
    highlights: ['Professionnel', 'Robuste', 'Tout-terrain'],
    usage: 'PRO',
    category: 'PRO',
    paymentOptions: ['PAY AS YOU GO', 'PAY MOLO', 'PAIEMENT COMPTANT'],
    rating: 4.9,
    reviews: 87,
    color: 'from-green-500 to-green-600'
  },
  {
    id: 'sunu',
    name: 'Sunu',
    basePrice: 1250000,
    basePriceWithPAYG: 1350000,
    image: '/sunu_proxy_emo.jpeg',
    description: 'Élégante et performante, parfaite pour la mobilité urbaine et les déplacements quotidiens',
    specs: {
      autonomie: '90 km',
      vitesse: '80 km/h',
      poids: '115 kg'
    },
    highlights: ['Urbain', 'Élégant', 'Confortable'],
    usage: 'PRO',
    category: 'PRO',
    paymentOptions: ['PAY AS YOU GO', 'PAY MOLO', 'PAIEMENT COMPTANT'],
    rating: 4.8,
    reviews: 64,
    color: 'from-blue-500 to-blue-600'
  },
  {
    id: 'teranga',
    name: 'Teranga',
    basePrice: 800000,
    image: '/Teranga-product1.jpg',
    description: 'Le choix économique et fiable pour tous, accessible et facile à prendre en main',
    specs: {
      autonomie: '100 km',
      vitesse: '45 km/h',
      poids: '85 kg'
    },
    highlights: ['Économique', 'Polyvalent', 'Accessible'],
    usage: 'PRO',
    category: 'PRO',
    paymentOptions: ['PAY AS YOU GO', 'PAY MOLO', 'PAIEMENT COMPTANT'],
    rating: 4.7,
    reviews: 52,
    color: 'from-amber-500 to-amber-600'
  },
  {
    id: 'teranga-plus',
    name: 'Teranga+',
    basePrice: 950000,
    image: '/teranga+_noir.jpg',
    imageWhite: '/teranga+_blanc.jpg',
    imageBlack: '/teranga+_noir.jpg',
    description: 'Idéal pour familles, particuliers, étudiants et trajets urbains',
    specs: {
      autonomie: '110 km',
      vitesse: '50 km/h',
      poids: '88 kg'
    },
    highlights: ['Familial', 'Moderne', 'Confortable'],
    usage: 'PARTICULIER',
    category: 'PARTICULIER',
    paymentOptions: ['PAIEMENT COMPTANT'],
    paymentNote: 'UNIQUEMENT PAIEMENT COMPTANT',
    colors: ['Noir', 'Blanc'],
    subtitle: 'Idéal pour familles, particuliers, étudiants et trajets urbains.',
    rating: 4.8,
    reviews: 23,
    color: 'from-purple-500 to-purple-600'
  },
  {
    id: 'omega',
    name: 'Omega',
    basePrice: 1800000,
    image: '/omega.png',
    description: 'TukTuk électrique robuste et polyvalent, idéal pour le transport de passagers et de marchandises en milieu urbain',
    specs: {
      autonomie: '120 km',
      vitesse: '45 km/h',
      capacite: '3-4 passagers'
    },
    highlights: ['Transport urbain', 'Polyvalent', 'Robuste'],
    usage: 'PRO',
    category: 'PRO',
    paymentOptions: ['PAY AS YOU GO', 'PAY MOLO', 'PAIEMENT COMPTANT'],
    subtitle: 'Solution économique et écologique pour les entrepreneurs et services de mobilité.',
    rating: 4.9,
    reviews: 12,
    color: 'from-teal-500 to-teal-600'
  }
];